import { Flex, IconButton, InputGroup, InputRightElement, Stack, useDisclosure } from "@chakra-ui/react"
import { getMessageHandlerClass } from "../AddSessionFormContent"
import { InputWrapper } from "../renderAddSessionForm"
import { StyledInput } from "../styled"
import { BaseMessagesHandlerSelect } from "./MessagesHandlerSelect"
import helperTexts from '../../../components/helperTexts.json'
import { useState } from "react"
import { FiEye, FiEyeOff } from "react-icons/fi"

const logonUsernamePasswordProviderClass = 'LogonUsernamePasswordProvider'

export const SessionMessageProviderSelect = (props) => {
    const { form, field, errors } = props
    const { name } = field
    const error = errors[name]
    const { watch, setValue } = form

    const sessionMessageProvider = watch(name)
    const innerObject = sessionMessageProvider ? sessionMessageProvider[Object.keys(sessionMessageProvider)[0]] : undefined
    const className = getMessageHandlerClass(sessionMessageProvider)
    const isLogonUsernamePasswordProvider = className === logonUsernamePasswordProviderClass

    const { isOpen: isViewOpen, onClose: closeView, onOpen: openView } = useDisclosure()

    const [showPassword, setShowPassword] = useState(false)

    return (
        <Stack>
            <BaseMessagesHandlerSelect
                {...props}
                isClearable
                isViewOpen={isViewOpen}
                closeView={closeView}
                openView={openView}
            />
            {isLogonUsernamePasswordProvider && !isViewOpen &&
                <Flex
                    mt={4}
                    gridColumn="1 / 3"
                    justifyContent={'space-between'}
                >
                    <InputWrapper 
                        name='login'
                        label='Login'
                        type='string'
                        helperText={helperTexts.username}
                        errors={[]}
                    >
                        <StyledInput
                            mb={2}
                            style={{ font: 'var(--code-font)' }}
                            focusBorderColor={error && 'red'}
                            isInvalid={!!error}
                            value={innerObject.username}
                            onChange={(e) => {
                                const value = e.target.value
                                const trimmedValue = value.trimStart()

                                innerObject.username = trimmedValue
                                setValue(name, sessionMessageProvider)
                            }}
                            onBlur={(e) => {
                                const value = e.target.value
                                const trimmedValue = value.trim()

                                innerObject.username = trimmedValue
                                setValue(name, sessionMessageProvider)
                            }}
                        />
                    </InputWrapper>
                    <InputWrapper 
                        name='password'
                        label='Password'
                        type='string'
                        helperText={helperTexts.password}
                        errors={[]}
                    >
                        <InputGroup>
                            <StyledInput
                                mb={2}
                                style={{ font: 'var(--code-font)' }}
                                type={showPassword ? 'text' : 'password'}
                                focusBorderColor={error && 'red'}
                                isInvalid={!!error}
                                value={innerObject.password}
                                onChange={(e) => {
                                    const value = e.target.value
                                    const trimmedValue = value.trimStart()

                                    innerObject.password = trimmedValue
                                    setValue(name, sessionMessageProvider)
                                }}
                                onBlur={(e) => {
                                    const value = e.target.value
                                    const trimmedValue = value.trim()

                                    innerObject.password = trimmedValue
                                    setValue(name, sessionMessageProvider)
                                }}
                            />
                            <InputRightElement>
                                <IconButton
                                    variant=''
                                    onClick={() => setShowPassword(!showPassword)}
                                    icon={showPassword ? <FiEyeOff /> : <FiEye />}
                                />
                            </InputRightElement>
                        </InputGroup>
                    </InputWrapper>
                </Flex>
            }
        </Stack>
    )
}